export const SSO_BYPASS_KEY = 'eleo.sso.bypass'
export const SSO_RETURN_URL_KEY = 'eleo.sso.return_url'
